export default __webpack_public_path__ + "static/img-zola-global-0a7831e1fadc71d2bbf4af2881c1c18a.png";